const checks = {
	'initial-letter': 'initial-letter:2',
};

for (const [key, value] of Object.entries(checks)) {
	if (!CSS.supports(value)) {
		document.body.classList.add(`no-${key}`);
	}
}
